<template>
  <!-- https://michalsnik.github.io/aos/ -->
  <v-container>
    <v-card class="mx-auto" max-width="550">
      <v-system-bar  color="pink darken-2" @click.stop="$router.push('/home')">
        <v-icon>home</v-icon>
      </v-system-bar>
  
      <v-app-bar color="#424242" dark dense @click.stop="$router.push('/home')">
        <v-toolbar-title>Sets</v-toolbar-title>
      </v-app-bar>
     
 
      <!-- 'Schedule a Set' Dialog -->
      <!--v-row justify="center">
        <v-dialog
          v-model="displayAddForm"
          persistent
          max-width="600px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Open Dialog
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
             
              <span class="text-h5 text-center">Schedule a Notification for: {{scheduleSetTitle}}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
              <v-row>
            
                <v-col  cols="12">
                  Microcise works best when you get reminders to exercise throughout your busy day. Scheduling a Set 
                  sends you web notifications with a direct link to the Set at the time you chose.
                  You can schedule the same set for multiple times through the day.
                </v-col>
              
              </v-row>

               <v-row>
                  <v-col cols="2"></v-col>
                  <v-col  cols="8">

                    <v-time-picker format="24hr"
                      v-model="setTime"
                      color="pink darken-2"
                      header-color="pink darken-2"
                    ></v-time-picker>
                  </v-col>
                  <v-col cols="2"></v-col>
                </v-row>

                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col cols="6"><v-btn v-if="setTime" flat light color="pink darken-2 white--text" @click="createSet()">Schedule for: {{ setTime}} </v-btn></v-col>
                  <v-col cols="3"><v-btn flat color="grey darken-1 white--text" @click="cancelSet()">Cancel</v-btn></v-col>
                  <v-col cols="1"></v-col>
            
                </v-row>
              
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row -->



      <!-- Header -->
      <v-row  dense class="text-center ma-1 pa-1">  
        <v-col  cols="4">
          Stretch <v-icon medium color="pink darken-2" >mdi-gymnastics</v-icon>
        </v-col>
        <v-col  cols="4">
          Move <v-icon medium color="pink darken-2" >mdi-run</v-icon>
        </v-col>
        <v-col  cols="4">
          Strengthen <v-icon medium color="pink darken-2" >mdi-weight-lifter</v-icon>
        </v-col>
      </v-row>
 
      <v-divider></v-divider>


<!-- CUSTOM SETS  -->    
      <v-row dense >  
        <v-col  v-for="(item, index) in setList" :key="index"  cols="12" >

          <v-list class="ma-0 pa-1">
            <v-list-group
                v-if="item.owner!='microcise'" class="blue lighten-5" 
                mandatory
                 :prepend-icon=calcSetType(index)
                active-class="bg-active"
                no-action
                @click="setMicrociseSetID(index)"
            >
              <template v-slot:activator>
                <v-list-item-content     

                color="primary"
                >
                  <!-- v-list-item-title v-text="microciseSetList[index].title"></v-list-item-title -->
                  <v-list-item-title  v-text="getSetTitle(index)"></v-list-item-title>
                </v-list-item-content>
              </template>
      
              <v-list-item
                v-for="child in item.exercises"
                :key="child.title"
            
              >
                <v-list-item-avatar>
                      <v-img :src="child.image" :max-width="40"></v-img>
                    </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="child.title"></v-list-item-title>
                </v-list-item-content>
               
              </v-list-item>

 
            <!-- append start set button -->
                <v-divider></v-divider>
                <v-row  dense  color="pink darken-2">  
                  <v-col  cols="4"></v-col>
                  <v-col  cols="4">
                    <div class="text-xs-center">
                      <v-card-actions class="justify-center" >

                          <!-- Note: uses the :right and :left attributes to place the Schedule and Remove buttons -->
                       
                          <!--v-btn  icon small light color="pink darken-2 white--text"  @click="createSet" :left="true" :absolute="true">
                            <v-icon medium>mdi-clock-outline</v-icon>
                          </v-btn --> 
                          <v-spacer></v-spacer>                          
                          <v-btn light color="pink darken-2 white--text"  @click="goToSession">
                            <span>Start Set</span>
                            <v-icon>play_circle</v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn v-if="item.owner!='microcise'" icon :right="true" :absolute="true"  color="pink darken-2" @click="deleteSet(index)"><v-icon>delete</v-icon>
                          </v-btn>
                      </v-card-actions>
                    </div>
                  </v-col>
                  <v-col  cols="4"></v-col>
              </v-row>  
              <v-divider></v-divider>

            </v-list-group>
<!-- Repeat all of above for that are Microcise sets.....-->
            <v-list-group
                v-else
                mandatory
                 :prepend-icon=calcSetType(index)
                active-class="bg-active"
                no-action
                @click="setMicrociseSetID(index)"
            >
              <template v-slot:activator>
                <v-list-item-content     

                color="primary"
                >
                  <!-- v-list-item-title v-text="microciseSetList[index].title"></v-list-item-title -->
                  <v-list-item-title  v-text="getSetTitle(index)"></v-list-item-title>
                </v-list-item-content>
              </template>
      
              <v-list-item
                v-for="child in item.exercises"
                :key="child.title"
            
              >
                <v-list-item-avatar>
                      <v-img :src="child.image" :max-width="40"></v-img>
                    </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="child.title"></v-list-item-title>
                </v-list-item-content>
               
              </v-list-item>

 
            <!-- append start set button -->
                <v-divider></v-divider>
                <v-row  dense  color="pink darken-2">  
                  <v-col  cols="4"></v-col>
                  <v-col  cols="4">
                    <div class="text-xs-center">
                      <v-card-actions class="justify-center" >

                          <!-- Note: uses the :right and :left attributes to place the Schedule and Remove buttons -->
                       
                          <v-btn  icon small light color="pink darken-2 white--text"  @click="createSet" :left="true" :absolute="true">
                            <v-icon medium>mdi-clock-outline</v-icon>
                          </v-btn> 
                          <v-spacer></v-spacer>                          
                          <v-btn light color="pink darken-2 white--text"  @click="goToSession">
                            <span>Start Set</span>
                            <v-icon>play_circle</v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn v-if="item.owner!='microcise'" icon :right="true" :absolute="true"  color="pink darken-2" @click="deleteSet(index)"><v-icon>delete</v-icon>
                          </v-btn>
                      </v-card-actions>
                    </div>
                  </v-col>
                  <v-col  cols="4"></v-col>
              </v-row>  
              <v-divider></v-divider>

            </v-list-group>


          </v-list>
         
        </v-col>
      </v-row>


      <v-row dense>  

          <v-col cols="12" >
         
              <div>
                <div>
                  <v-card-title class="text-h6  text-center grey--text text--darken-2 blue lighten-5">
                  <v-spacer></v-spacer>
                  Create your own Set   <v-icon medium color="grey darken-2" >mdi-human-handsup</v-icon>
                  <v-spacer></v-spacer>
                  </v-card-title>
  
                  <v-card-text class="ma-2 pa-0">
        
                  <p class="mt-0 mr-1 pa-0 text-center">Create personalised Sets to meet your goals (stretch, move, strengthen) </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="pink darken-2 white--text" @click="$router.push('/newset')">Create a new Set</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </div>
              </div>
           
           </v-col>

        </v-row>

    </v-card>
    <v-navigation-drawer
     class="grey lighten-4"
      v-model="drawer"
      absolute
      bottom
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item @click="$router.push('/')">
            <v-list-item-icon>
              <v-icon>home</v-icon>
              <span>Home</span>
            </v-list-item-icon>        
          </v-list-item>

          <v-list-item @click="$router.push('/sets')">
            <v-list-item-icon>
              <v-icon>list</v-icon>
              <span>Sessions</span>
            </v-list-item-icon>    
          </v-list-item>

          <v-list-item @click="$router.push('/')">
            <v-list-item-icon>
              <v-icon>schedule</v-icon>
              <span>Schedule</span>
            </v-list-item-icon>   
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

  </v-container>

</template>

<style>
.v-progress-circular {
margin: 1rem;
}
</style>



<script>
import { Auth } from 'aws-amplify'  
import queries from '../api/queries'

export default {

  name: 'Sets',

  data: () => ({
    tempTitle: "FredBilly",
    dialog: false,
    time: '20:30',
    timeSelected: false,
    setTime: null,
    displayAddForm:false,    
    setSelected: 0,
    panelsOpen: 1,
    links: [],
    drawer: false,
    group: null,
    removeDialog: false,
    setList: [],  // the list of current Sets
    microciseSetList: []
  
  }),
  async created() {

    this.userAuthData = await Auth.currentUserInfo();

    this.setList = await queries.listSetExercisesWithFilter("microcise"); // a custom query

    // add users sets to the list....
    let userSetList =await queries.listSetExercisesWithFilter(this.userAuthData.username);

    for(let i=0;i<userSetList.length;i++) {
      this.setList.push(userSetList[i])
    }

  },
  async mounted() {

    },   
  computed: {
       // a computed getter
       scheduleSetTitle() {
        let title=""
        try {
          title = this.setList[this.setSelected].title
        } catch (ex) {
          title=""
        } 
      return (title)
    }
  },       
  methods: {
    cancelSet() {
        this.setTime="";
        this.displayAddForm=false;
      },
    createSet() {
        this.displayAddForm=true;
        
      },       
    setMicrociseSetID(index) {
        this.setSelected = index
      },
      goToSession() {
        this.$router.push({ path: 'session', query: { setID: this.setList[this.setSelected].id } })
      },
      calcSetType(index) {

        let setType=this.setList[index].setType

        if( setType === "user") {    
          return("mdi-human-handsup")
        } else if( setType === "stretch") {
            return("mdi-gymnastics")
        } else if( setType === "move")  {
          return("mdi-run")
        } else if( setType === "strength") {
          return("mdi-weight-lifter")
        } else { 
          return("mdi-human-handsup")
        }
        
      },      
      async deleteSet(index) {
        //
        // TO DO. Check if this Set is in the Users Schedule. If so, pop up warning and confirmation of deletion
        // If delete, delete from Schedule as well
        //
        await queries.deleteSet(this.setList[index].id);
        this.setList.splice(index, 1);
      },      
      getSetDuration(index) {
          let setDuration=0;
          let exercises = this.setList[index].exercises;

          exercises.forEach (function (exercise) {

            setDuration = setDuration + exercise.duration;
          });

          setDuration=setDuration/10;
          var minutes = Math.floor(setDuration / 60);
          //var seconds = setDuration - minutes * 60;
          (6).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})

          //return(minutes + ":" + (seconds).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false}));
          return(minutes);
        },
      getSetTitle(index) {
        let title=""
        try {
          title = this.setList[index].title + " (" + this.getSetDuration(index) + " mins)"
        } catch (ex) {
          title=""
        } 

        return title;
        },
      getExerciseTitle(exercise) {
        return exercise.title + " (" + exercise.duration + ")";
        },
  }          
}
</script>
